import React, { useState } from 'react';

import { FormattedMessage } from 'react-intl';
import Alert from '~/ui/components/Alert/Alert';
import Box from '~/ui/components/Box/Box';

const SearchReIndexInProgressWarning = ({ fullyIndexed, docCountIndexing }) => {
  const [showAlert, setShowAlert] = useState(true);

  return showAlert && !fullyIndexed ? (
    <Box mb={4}>
      <Alert
        onDismiss={() => setShowAlert(false)}
        ariaLive="assertive"
        enableIcon
        variant="warning"
      >
        <FormattedMessage
          id="SearchReIndexInProgressWarning.indexingMessage"
          defaultMessage="{docCount} document {docCount, plural, one {record is} other {records are}} currently being updated and may not be accurately represented in Search results while this update is in progress. Please check again later to confirm that your search query has returned a full set of results."
          description="Warning message displayed when documents are being re-indexed. Example: docCount = 150"
          values={{
            docCount: docCountIndexing,
          }}
        />
      </Alert>
    </Box>
  ) : null;
};

export default SearchReIndexInProgressWarning;
